import io from 'socket.io-client'

// Module-level singleton socket connection.
//
// This used to be created inline in the App() function body, which is fragile
// under React StrictMode (the function body runs twice in dev, which would
// open two connections) and forced the socket to be prop-drilled from App
// down through StreamRecord to PopUp/usePitchSubmit. Creating it once here
// and importing the same instance wherever it's needed avoids both problems.
//
// Connection params (transports/autoUpgrade/eio) are unchanged from the
// original inline `io.connect` call — do not modify them.
//
// The URL itself is overridable via CRA env vars so ops can point at a
// different socket endpoint without a code change; when the env vars are
// unset (the default), these resolve to the exact same hardcoded URLs as
// before.
export const SOCKET_URL = process.env.REACT_APP_SOCKET_URL || "https://tsocket.stats-insight.com/"
export const SOCKET_TEST_URL = process.env.REACT_APP_SOCKET_TEST_URL || "https://socket_tp.stats-insight.com/"

const socket = io.connect(SOCKET_URL, {
  transports: ['polling'],
  autoUpgrade: false,
  eio: 3
});

socket.on("connect_error", (err) => {
  console.log(err)
  console.log(`connect_error due to ${err.message}`);
});
socket.on("connect", (res) => {
  console.log("connected") //, socketURL)
})
socket.on('disconnect', (res) => {
  console.log("disconnect")
})

export default socket
